import { carriers } from 'types/timetableServices';

export const applicableCarriers = [carriers.ER, carriers.ES];

export const DISRUPTION_DELAY_THRESHOLD_MINUTES = 30;
